/* eslint-disable */ !(function (t) {
  t.Redactor.prototype.clips = function () {
    return {
      init: function () {
        var i = [
          [this.lang.get('firstname'), '*|FNAME|*'],
          [this.lang.get('fullname'), '*|NAME|*']
        ];
        this.clips.template = t('<ul id="redactor-modal-list">');
        for (var e = 0; e < i.length; e++) {
          var s = t('<li>'),
            l = t('<a href="#" class="redactor-clip-link">').text(i[e][0]),
            o = t('<div class="redactor-clip">').hide().html(i[e][1]);
          s.append(l), s.append(o), this.clips.template.append(s);
        }
        this.modal.addTemplate(
          'clips',
          '<section>' +
            this.utils.getOuterHtml(this.clips.template) +
            '</section>'
        );
        var a = this.button.add('clips', this.lang.get('merge_tags'));
        this.button.addCallback(a, this.clips.show);
      },
      show: function () {
        this.modal.load('clips', this.lang.get('merge_tags'), 400),
          this.modal.createCancelButton(),
          t('#redactor-modal-list')
            .find('.redactor-clip-link')
            .each(t.proxy(this.clips.load, this)),
          this.selection.save(),
          this.modal.show();
      },
      load: function (i, e) {
        t(e).on(
          'click',
          t.proxy(function (i) {
            i.preventDefault(), this.clips.insert(t(e).next().html());
          }, this)
        );
      },
      insert: function (t) {
        this.selection.restore(),
          this.insert.htmlWithoutClean(t),
          this.modal.close(),
          this.observe.load();
      }
    };
  };
})(jQuery);
